<div class="container" *ngIf="voucherItem">
    <div class="row g-3">
        <div class="col-md-6 col-12">
            <div class="card p-3 voucher-content ">
                <div class="d-flex">
                    <div class="voucher-image">
                        <img src="{{voucherItem.Image}}" alt="">
                    </div>
                    <div class="voucher-name ms-3">
                        <p>{{voucherItem.Name}}</p>
                        <span>วันที่หมดอายุ</span>
                        <br>
                        <p> {{voucherItem.Expire_start | date:'dd/MM/yyyy'}} -
                            {{voucherItem.Expire_end | date:'dd/MM/yyyy'}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <br>
    <div class="row g-3">
        <div class="col-12 ">
            <div class="card p-3">
                <div class="row g-3">
                    <div class="col-12">
                        ค้นหาสมาชิก
                        <div class="input-icon-end">
                            <input type="text" class="form-control" placeholder="ค้นหาสมาชิกด้วยเบอร์โทร"
                                [(ngModel)]="findMember" (change)="getMemberItems()" #tel>
                            <span class="material-symbols-outlined">
                                search
                            </span>
                        </div>
                        <br>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        ค้นหาด้วย RANK
                    </div>
                    <div class="col-md-3 col-6 d-flex align-items-center" *ngFor="let rk of rankItems">
                        <input type="radio" name="rank" (click)="findRank(rk)">
                        <div class="rank-image ms-2 me-2">
                            <img width="25px" src="{{rk.RankImage}}" alt="">
                        </div>
                        <span> {{rk.RankName}}</span>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-6">
                        <div class="d-flex align-items-center">
                            <input type="checkbox" [checked]="selectMemberAll" (click)="selectAll()">
                            <span class="ms-2">เลือกทั้งหมด</span>
                        </div>
                    </div>
                    <div class="col-6 text-end">
                        <button class="btn btn-primary btn-sm" (click)="sendToList()">เลือก</button>
                    </div>
                    <div class="col-12 mt-3">
                        รายชื่อสมาชิก
                        <br>
                        <div class="scrollbar member pe-2">
                            <table class="table align-middle">
                                <tbody>
                                    <tr *ngFor="let mb of memberFindItems">
                                        <td>
                                            <div class="d-flex align-items-center">
                                                <input type="checkbox" [checked]="mb.Select" (click)="selectMember(mb)">
                                                <div class="member-rank-image ms-2">
                                                    <img width="25px" src="{{mb.Rank_image}}" alt="">
                                                </div>
                                                <span class="ms-2"> {{mb.Member_name}}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>



<p-dialog header="ส่งบัตรกำนัล" [(visible)]="viewVoucher" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }">
    <ng-container *ngIf="memberListSend.length > 0">
        <div class="row">
            <div class="col-12">
                <h3>ส่งให้บัตรกำนัลจำนวนกี่ใบ</h3>
                <input type="number" class="form-control" placeholder="กรอกจำนวนบัตรกำนัลที่ต้องการส่ง"
                    [(ngModel)]="voucherAmount">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-12">
                <div class="d-flex">
                    <span> สมาชิกที่ถูกเลือก</span>
                    <div class="ms-auto">
                        <button class="btn btn-primary btn-sm  me-2" (click)="sendVoucher()">
                            ส่งบัตรกำนัล
                        </button>
                        <button class="btn btn-danger btn-sm" (click)="removeAll()">
                            ลบทั้งหมด
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-12 mt-3">
                <div class="scrollbar member memberSend">
                    <table class="table align-middle">
                        <tbody>
                            <tr *ngFor="let mls of memberListSend">
                                <td>
                                    <div class="d-flex align-items-center">
                                        <div class="member-rank-image ms-2">
                                            <img width="25px" src="{{mls.Rank_image}}" alt="">
                                        </div>
                                        <span class="ms-2 w-100"> {{mls.Member_name}}</span>
                                    </div>
                                </td>
                                <td>
                                    <button class="btn btn-danger float-end" (click)="deleteMemberSend(mls)">ลบ</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <ng-container *ngFor="let mls of memberListSend">
                    <div class="member-item d-flex align-items-center p-2">
                        <div class="member-rank-image ms-2">
                            <img width="25px" src="{{mls.Rank_image}}" alt="">
                        </div>
                        <span class="ms-2 w-100"> {{mls.Member_name}}</span>
                        <button class="btn btn-danger float-end" (click)="deleteMemberSend(mls)">ลบ</button>
                    </div>
                    <hr>
                </ng-container> -->
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="memberListSend.length == 0">
        <br>
        <h5>เลือกสมัครชิกที่ต้องการส่งบัตรกำนัล</h5>
    </ng-container>
</p-dialog>